export default "https://assets.egbcdn.net/assets/packs/_/images/big-dark-logo-617a2f1bc90e0dbb9cd736413972f593.png";